




































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import Poles from '@/components/sites/Poles.vue';
import ReportFileTable from '@/components/ReportFileTable.vue';
import DetailMixin from '@/mixins/DetailMixin';
import FieldDefs from './FieldDefs';
import { LineValue } from '@/interfaces';

@Component({
  components: {
    Poles,
    ReportFileTable
  }
})
export default class DeviceDetail extends Mixins(DetailMixin) {
  public version = 1;
  public tableCfg = FieldDefs;
  public priv = this.getTableCfg(this.tableCfg, 'priv');

  public get writeFilesPrivilege() {
    return this.roleCheck(this.priv, 'Write');
  }

  public formatLine(line, siteNr): LineValue {
    return {
      id: 0,
      siteinfoline_id: line.id,
      value: line.default,
      value_index: line.default_index,
      linedatatype: line.linedatatype,
      name: line.name,
      title_nl: line.title_nl,
      title_fr: line.title_fr,
      values_fr: line.values_fr,
      values_nl: line.values_nl,
      site: line.site,
      site_nr: siteNr
    };
  }

  public getGeneralLines(lines) {
    return lines
      ? lines.filter(
          (site) => !site.name.includes('_1') && !site.name.includes('_2')
        )
      : [];
  }

  public getEntryLines(lines) {
    return lines ? lines.filter((site) => site.name.includes('_1')) : [];
  }

  public getExitLines(lines) {
    return lines ? lines.filter((site) => site.name.includes('_2')) : [];
  }

  public async getMostRecentReport(rec, siteId) {
    const response: any = await this.api.getTableData(
      this.$store,
      '/sitereports/',
      {
        site_id: siteId,
        most_recent: true
      }
    );
    if (response) {
      const mostRecentReports = response.data;
      if (mostRecentReports.data.length > 0) {
        // Most recent report exists
        const reportId = mostRecentReports.data[0].id;
        const reportResponse: any = await this.api.getRecord(
          this.$store,
          '/sitereports/' + reportId
        );
        if (reportResponse) {
          const report = reportResponse.data;
          rec.sitereport_id = reportId;
          const reportlines: any[] = [];
          for (const line of report.reportlines) {
            line.id = 0;
            reportlines.push(line);
          }
          rec.reportlines = reportlines;
          rec.poles = report.poles;
          this.version += 1;
        }
      }
    }
  }

  // Get lines of the site
  public async getSiteLines(rec) {
    const ref: any = this.$refs.layout;
    const id = rec.site_id;
    if (id) {
      const siteResponse: any = await this.api.getRecord(
        this.$store,
        '/sites/' + id
      );
      if (siteResponse) {
        const site = siteResponse.data;
        rec.site.user_address_id = site.user_address_id;
        rec.site.admin_address_id = site.admin_address_id;
        rec.site.import_address_id = site.import_address_id;
        rec.site.owner_address_id = site.owner_address_id;
        rec.site.roadauthority_address_id = site.roadauthority_address_id;
        rec.site.supervisor_id = site.supervisor_id;
        rec.site.projectmanager_id = site.projectmanager_id;
        rec.site.installation_nr = site.installation_nr;
        rec.site.trafficlight = site.trafficlight;
        rec.site.highway = site.highway;
        rec.site.start_site_count = site.start_site_count;
        rec.site.end_site_count = site.end_site_count;
        rec.site.em_uuid = site.em_uuid;
        rec.sitelines = site.sitelines;

        const site_count = site.site_count;
        rec.poles = new Array(site_count).fill({
          date_in: null,
          date_out: null
        });
        // Remove list observer
        rec.poles = JSON.parse(JSON.stringify(rec.poles));
        rec.pole_count = rec.poles.length;

        const siteInfoId = site.sitetype.siteinfo_id;
        if (siteInfoId) {
          const SiteInfoLinesResponse: any = await this.api.getLines(
            this.$store,
            '/siteinfos/' + siteInfoId
          );
          if (SiteInfoLinesResponse) {
            const lines: LineValue[] = [];
            for (const line of SiteInfoLinesResponse.data.data) {
              if (line.site) {
                for (let i = 1; i <= site_count; i++) {
                  const l = this.formatLine(line, i);
                  lines.push(l);
                }
              } else {
                const l = this.formatLine(line, null);
                lines.push(l);
              }
            }
            rec.reportlines = lines;
          }
        } else {
          rec.reportlines = [];
          rec.poles = [];
        }
      }
      // Get most recent report
      this.getMostRecentReport(rec, id);
    } else {
      rec.sitelines = [];
      rec.reportlines = [];
      rec.poles = [];
    }
    // Let detail layout and roles component know that something changed
    ref.$refs.form.$emit('input');
    this.version += 1;
  }

  public initPrivileges(rec) {
    const ref: any = this.$refs.layout;
    if (rec.conclusion && !this.roleCheck(this.priv, 'Manage')) {
      ref.customWritePriv = false;
    }
  }

  public customSave() {
    const ref: any = this.$refs.layout;
    this.saveWithFiles(this.tableCfg.apiUrl);
    this.initPrivileges(ref.rec);
  }
}
